
import { ChangeEvent, useRef } from "react";
import ToolbarButton from "../Toolbar/toolbarButton";
import { useAppDispatch } from "../../../store/hooks";
import { LoadPlanData } from "../../../store/ioThunk";
import { modelReset } from "../../../store/model";

interface ToolbarButtonOpenProps {
  icon: '.png';
  tooltip: string;
  toolname: string;
}
interface UserData {
  type: 'userData'
}
export type ImportLineShape = LineShape & { lineType: number[] }
export type ImportGeometricShape = GeometricShape | ImportLineShape | UserData
// export type ImportGeometricShape = GeometricShape & { lineType: number[] } | UserData
export type JSONGeometricShape = GeometricShape & { rot?: number }

const ToolbarButtonOpen = ({ icon, tooltip, toolname }: ToolbarButtonOpenProps) => {
  const hiddenFileInput = useRef<HTMLInputElement>(null)
  const dispatch = useAppDispatch()

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {

      const fileUploaded = event.target.files;
      dispatch(modelReset())
      dispatch(LoadPlanData(fileUploaded, ["fitToScreen"]))
      // handleFile(fileUploaded);
    }
  };

  const handleClick = () => {
    if (hiddenFileInput.current) {
      hiddenFileInput.current.click();
    }
  };

  return (
    <><ToolbarButton
      onClick={handleClick}
      icon={icon}
      tooltip={tooltip}
      toolname={toolname}
    ></ToolbarButton><input
        type="file"
        onChange={handleChange}
        ref={hiddenFileInput}
        style={{ display: 'none' }} // Make the file input element invisible
      /></>
  )
}

export default ToolbarButtonOpen;


